import { hrmsGet } from "../api/api";

function unwrapList(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data?.content)) return response.data.content;
  if (Array.isArray(response?.content)) return response.content;
  if (Array.isArray(response?.data)) return response.data;
  return [];
}

function getInitials(name) {
  if (!name) return "?";
  const parts = String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
  }
  return parts[0].slice(0, 2).toUpperCase();
}

function mapReportee(item) {
  const id = Number(item?.empId ?? item?.employeeId ?? item?.emp_Id ?? item?.id);
  const name =
    item?.empName ||
    item?.employeeName ||
    item?.fullName ||
    item?.name ||
    [item?.firstName, item?.lastName].filter(Boolean).join(" ").trim() ||
    (Number.isFinite(id) ? `Employee #${id}` : "Employee");

  return {
    id,
    name,
    initials: getInitials(name),
  };
}

export async function getManagerReportees(
  managerId,emp_Id,
  { page = 0, size = 10, sortBy = "emp_Id", sortDir = "ASC" } = {}
) {
  const numericManagerId = Number(managerId);
  if (!Number.isFinite(numericManagerId) || numericManagerId <= 0) {
    return [];
  }

  const params = new URLSearchParams({
    managerId: String(numericManagerId),
    // empId: String(firstName),
    page: String(page),
    size: String(size),
    sortBy,
    sortDir,
  });

  const response = await hrmsGet(
    `/current-employment/search?${params.toString()}`,
    "HR02S"
  );

  return unwrapList(response)
    .map(mapReportee)
    .filter((employee) => Number.isFinite(employee.id) && employee.id > 0)
    .sort((a, b) => a.name.localeCompare(b.name));
}
